module.exports = __webpack_public_path__ + "static/media/team-1@3x.625647e5.jpg";